/**
 * Dictionnaire statique des codes postaux belges → commune principale.
 * Source : bpost – environ 1 150 entrées.
 * Réutilisable dans tout formulaire nécessitant une auto-complétion ville.
 */
export const BELGIAN_POSTAL_CODES: Record<string, string> = {
  "1000": "Bruxelles",
  "1005": "Bruxelles",
  "1006": "Bruxelles",
  "1007": "Bruxelles",
  "1008": "Bruxelles",
  "1009": "Bruxelles",
  "1010": "Bruxelles",
  "1011": "Bruxelles",
  "1012": "Bruxelles",
  "1020": "Bruxelles",
  "1030": "Schaerbeek",
  "1031": "Bruxelles",
  "1033": "Bruxelles",
  "1035": "Bruxelles",
  "1040": "Etterbeek",
  "1041": "Bruxelles",
  "1043": "Bruxelles",
  "1044": "Bruxelles",
  "1046": "Bruxelles",
  "1047": "Bruxelles",
  "1048": "Bruxelles",
  "1049": "Bruxelles",
  "1050": "Ixelles",
  "1060": "Saint-Gilles",
  "1070": "Anderlecht",
  "1080": "Molenbeek-Saint-Jean",
  "1081": "Koekelberg",
  "1082": "Berchem-Sainte-Agathe",
  "1083": "Ganshoren",
  "1090": "Jette",
  "1100": "Bruxelles",
  "1101": "Bruxelles",
  "1105": "Bruxelles",
  "1110": "Bruxelles",
  "1120": "Bruxelles",
  "1130": "Bruxelles",
  "1140": "Evere",
  "1150": "Woluwe-Saint-Pierre",
  "1160": "Auderghem",
  "1170": "Watermael-Boitsfort",
  "1180": "Uccle",
  "1190": "Forest",
  "1200": "Woluwe-Saint-Lambert",
  "1210": "Saint-Josse-ten-Noode",
  "1300": "Wavre",
  "1301": "Bierges",
  "1310": "La Hulpe",
  "1315": "Glimes",
  "1320": "Beauvechain",
  "1325": "Chaumont-Gistoux",
  "1330": "Rixensart",
  "1331": "Rosières",
  "1332": "Genval",
  "1340": "Ottignies-Louvain-la-Neuve",
  "1341": "Céroux-Mousty",
  "1342": "Limelette",
  "1348": "Louvain-la-Neuve",
  "1350": "Orp-Jauche",
  "1357": "Hélécine",
  "1360": "Perwez",
  "1367": "Ramillies",
  "1370": "Jodoigne",
  "1380": "Lasne",
  "1390": "Grez-Doiceau",
  "1400": "Nivelles",
  "1401": "Baulers",
  "1404": "Bornival",
  "1410": "Waterloo",
  "1420": "Braine-l'Alleud",
  "1421": "Ophain-Bois-Seigneur-Isaac",
  "1428": "Lillois-Witterzée",
  "1430": "Rebecq",
  "1435": "Mont-Saint-Guibert",
  "1440": "Braine-le-Château",
  "1450": "Chastre",
  "1457": "Walhain",
  "1460": "Ittre",
  "1461": "Haut-Ittre",
  "1470": "Genappe",
  "1471": "Loupoigne",
  "1472": "Vieux-Genappe",
  "1473": "Glabais",
  "1474": "Ways",
  "1476": "Houtain-le-Val",
  "1480": "Tubize",
  "1490": "Court-Saint-Étienne",
  "1495": "Villers-la-Ville",
  "1500": "Halle",
  "1501": "Buizingen",
  "1502": "Lembeek",
  "1540": "Herne",
  "1541": "Herfelingen",
  "1547": "Biévène",
  "1560": "Hoeilaart",
  "1570": "Galmaarden",
  "1600": "Sint-Pieters-Leeuw",
  "1601": "Ruisbroek",
  "1602": "Vlezenbeek",
  "1620": "Drogenbos",
  "1630": "Linkebeek",
  "1640": "Rhode-Saint-Genèse",
  "1650": "Beersel",
  "1651": "Lot",
  "1652": "Alsemberg",
  "1653": "Dworp",
  "1654": "Huizingen",
  "1670": "Pepingen",
  "1671": "Elingen",
  "1673": "Beert",
  "1674": "Bellingen",
  "1700": "Dilbeek",
  "1701": "Itterbeek",
  "1702": "Groot-Bijgaarden",
  "1703": "Schepdaal",
  "1730": "Asse",
  "1731": "Zellik",
  "1740": "Ternat",
  "1741": "Wambeek",
  "1742": "Sint-Katherina-Lombeek",
  "1745": "Opwijk",
  "1750": "Lennik",
  "1755": "Gooik",
  "1760": "Roosdaal",
  "1761": "Borchtlombeek",
  "1770": "Liedekerke",
  "1780": "Wemmel",
  "1785": "Merchtem",
  "1790": "Affligem",
  "1800": "Vilvoorde",
  "1804": "Cargovil",
  "1818": "Steenokkerzeel",
  "1820": "Melsbroek",
  "1830": "Machelen",
  "1831": "Diegem",
  "1840": "Londerzeel",
  "1850": "Grimbergen",
  "1851": "Humbeek",
  "1852": "Beigem",
  "1853": "Strombeek-Bever",
  "1860": "Meise",
  "1861": "Wolvertem",
  "1880": "Kapelle-op-den-Bos",
  "1910": "Kampenhout",
  "1930": "Zaventem",
  "1931": "Brucargo",
  "1932": "Sint-Stevens-Woluwe",
  "1933": "Sterrebeek",
  "1934": "Nossegem",
  "1935": "Zaventem",
  "1940": "Wezembeek-Oppem",
  "1950": "Kraainem",
  "1970": "Wezembeek-Oppem",
  "1980": "Zemst",
  "1981": "Hofstade",
  "1982": "Elewijt",
  "2000": "Anvers",
  "2018": "Anvers",
  "2020": "Anvers",
  "2030": "Anvers",
  "2040": "Anvers",
  "2050": "Anvers",
  "2060": "Anvers",
  "2070": "Zwijndrecht",
  "2100": "Deurne",
  "2110": "Wijnegem",
  "2140": "Borgerhout",
  "2150": "Borsbeek",
  "2160": "Wommelgem",
  "2170": "Merksem",
  "2180": "Ekeren",
  "2200": "Herentals",
  "2220": "Heist-op-den-Berg",
  "2230": "Herselt",
  "2235": "Houtvenne",
  "2240": "Zandhoven",
  "2242": "Pulderbos",
  "2243": "Pulle",
  "2250": "Olen",
  "2260": "Westerlo",
  "2270": "Herenthout",
  "2275": "Lille",
  "2280": "Grobbendonk",
  "2288": "Bouwel",
  "2290": "Vorselaar",
  "2300": "Turnhout",
  "2310": "Rijkevorsel",
  "2320": "Hoogstraten",
  "2321": "Meer",
  "2322": "Minderhout",
  "2323": "Wortel",
  "2328": "Meerle",
  "2330": "Merksplas",
  "2340": "Beerse",
  "2350": "Vosselaar",
  "2360": "Oud-Turnhout",
  "2370": "Arendonk",
  "2380": "Ravels",
  "2381": "Weelde",
  "2382": "Poppel",
  "2387": "Baarle-Hertog",
  "2390": "Malle",
  "2400": "Mol",
  "2430": "Laakdal",
  "2431": "Eindhout",
  "2440": "Geel",
  "2450": "Meerhout",
  "2460": "Kasterlee",
  "2470": "Retie",
  "2480": "Dessel",
  "2490": "Balen",
  "2500": "Lier",
  "2520": "Ranst",
  "2530": "Boechout",
  "2531": "Vremde",
  "2540": "Hove",
  "2547": "Lint",
  "2550": "Kontich",
  "2560": "Nijlen",
  "2570": "Duffel",
  "2580": "Putte",
  "2590": "Berlaar",
  "2600": "Berchem",
  "2610": "Wilrijk",
  "2620": "Hemiksem",
  "2627": "Schelle",
  "2630": "Aartselaar",
  "2640": "Mortsel",
  "2650": "Edegem",
  "2660": "Hoboken",
  "2800": "Malines",
  "2801": "Heffen",
  "2811": "Hombeek",
  "2812": "Muizen",
  "2820": "Bonheiden",
  "2830": "Willebroek",
  "2840": "Rumst",
  "2845": "Niel",
  "2850": "Boom",
  "2860": "Sint-Katelijne-Waver",
  "2861": "Onze-Lieve-Vrouw-Waver",
  "2870": "Puurs-Sint-Amands",
  "2880": "Bornem",
  "2890": "Sint-Amands",
  "2900": "Schoten",
  "2910": "Essen",
  "2920": "Kalmthout",
  "2930": "Brasschaat",
  "2940": "Stabroek",
  "2950": "Kapellen",
  "2960": "Brecht",
  "2970": "Schilde",
  "2980": "Zoersel",
  "2990": "Wuustwezel",
  "3000": "Louvain",
  "3001": "Heverlee",
  "3010": "Kessel-Lo",
  "3012": "Wilsele",
  "3018": "Wijgmaal",
  "3020": "Herent",
  "3040": "Huldenberg",
  "3050": "Oud-Heverlee",
  "3051": "Sint-Joris-Weert",
  "3052": "Blanden",
  "3053": "Haasrode",
  "3054": "Vaalbeek",
  "3060": "Bertem",
  "3061": "Leefdaal",
  "3070": "Kortenberg",
  "3071": "Erps-Kwerps",
  "3078": "Everberg",
  "3080": "Tervuren",
  "3090": "Overijse",
  "3110": "Rotselaar",
  "3111": "Wezemaal",
  "3118": "Werchter",
  "3120": "Tremelo",
  "3128": "Baal",
  "3130": "Begijnendijk",
  "3140": "Keerbergen",
  "3150": "Haacht",
  "3190": "Boortmeerbeek",
  "3191": "Hever",
  "3200": "Aarschot",
  "3201": "Langdorp",
  "3202": "Rillaar",
  "3210": "Lubbeek",
  "3211": "Binkom",
  "3212": "Pellenberg",
  "3220": "Holsbeek",
  "3221": "Nieuwrode",
  "3270": "Scherpenheuvel-Zichem",
  "3271": "Averbode",
  "3272": "Testelt",
  "3290": "Diest",
  "3293": "Kaggevinne",
  "3294": "Molenstede",
  "3300": "Tirlemont",
  "3320": "Hoegaarden",
  "3321": "Outgaarden",
  "3350": "Linter",
  "3360": "Bierbeek",
  "3370": "Boutersem",
  "3380": "Glabbeek",
  "3384": "Attenrode",
  "3390": "Tielt-Winge",
  "3391": "Meensel-Kiezegem",
  "3400": "Landen",
  "3401": "Walshoutem",
  "3404": "Attenhoven",
  "3440": "Zoutleeuw",
  "3450": "Geetbets",
  "3454": "Rummen",
  "3460": "Bekkevoort",
  "3461": "Molenbeek-Wersbeek",
  "3470": "Kortenaken",
  "3471": "Hoeleden",
  "3500": "Hasselt",
  "3501": "Wimmertingen",
  "3510": "Kermt",
  "3511": "Kuringen",
  "3512": "Stevoort",
  "3520": "Zonhoven",
  "3530": "Houthalen-Helchteren",
  "3540": "Herk-de-Stad",
  "3545": "Halen",
  "3550": "Heusden-Zolder",
  "3560": "Lummen",
  "3570": "Alken",
  "3580": "Beringen",
  "3581": "Beverlo",
  "3582": "Koersel",
  "3583": "Paal",
  "3590": "Diepenbeek",
  "3600": "Genk",
  "3620": "Lanaken",
  "3621": "Rekem",
  "3630": "Maasmechelen",
  "3631": "Boorsem",
  "3640": "Kinrooi",
  "3650": "Dilsen-Stokkem",
  "3660": "Oudsbergen",
  "3665": "As",
  "3668": "Niel-bij-As",
  "3670": "Oudsbergen",
  "3680": "Maaseik",
  "3690": "Zutendaal",
  "3700": "Tongres",
  "3717": "Herstappe",
  "3720": "Kortessem",
  "3721": "Vliermaalroot",
  "3722": "Wintershoven",
  "3723": "Guigoven",
  "3724": "Vliermaal",
  "3730": "Hoeselt",
  "3732": "Schalkhoven",
  "3740": "Bilzen",
  "3742": "Martenslinde",
  "3746": "Hoelbeek",
  "3770": "Riemst",
  "3790": "Fourons",
  "3791": "Remersdaal",
  "3792": "Fouron-Saint-Pierre",
  "3793": "Teuven",
  "3798": "Fouron-le-Comte",
  "3800": "Saint-Trond",
  "3803": "Wilderen",
  "3806": "Velm",
  "3830": "Wellen",
  "3831": "Herten",
  "3832": "Ulbeek",
  "3840": "Borgloon",
  "3850": "Nieuwerkerken",
  "3870": "Heers",
  "3890": "Gingelom",
  "3891": "Borlo",
  "3900": "Pelt",
  "3910": "Pelt",
  "3920": "Lommel",
  "3930": "Hamont-Achel",
  "3940": "Hechtel-Eksel",
  "3941": "Eksel",
  "3945": "Ham",
  "3950": "Bocholt",
  "3960": "Bree",
  "3970": "Leopoldsburg",
  "3971": "Heppen",
  "3980": "Tessenderlo",
  "3990": "Peer",
  "4000": "Liège",
  "4020": "Liège",
  "4030": "Grivegnée",
  "4031": "Angleur",
  "4032": "Chênée",
  "4040": "Herstal",
  "4041": "Vottem",
  "4042": "Liers",
  "4050": "Chaudfontaine",
  "4051": "Vaux-sous-Chèvremont",
  "4052": "Beaufays",
  "4053": "Embourg",
  "4100": "Seraing",
  "4101": "Jemeppe-sur-Meuse",
  "4102": "Ougrée",
  "4120": "Neupré",
  "4121": "Neuville-en-Condroz",
  "4130": "Esneux",
  "4140": "Sprimont",
  "4141": "Louveigné",
  "4160": "Anthisnes",
  "4170": "Comblain-au-Pont",
  "4180": "Hamoir",
  "4190": "Ferrières",
  "4210": "Burdinne",
  "4217": "Héron",
  "4218": "Couthuin",
  "4219": "Wasseiges",
  "4250": "Geer",
  "4257": "Berloz",
  "4260": "Braives",
  "4261": "Latinne",
  "4263": "Tourinne",
  "4280": "Hannut",
  "4287": "Lincent",
  "4300": "Waremme",
  "4317": "Faimes",
  "4340": "Awans",
  "4342": "Hognoul",
  "4347": "Fexhe-le-Haut-Clocher",
  "4350": "Remicourt",
  "4351": "Hodeige",
  "4357": "Donceel",
  "4360": "Oreye",
  "4367": "Crisnée",
  "4400": "Flémalle",
  "4420": "Saint-Nicolas",
  "4430": "Ans",
  "4431": "Loncin",
  "4432": "Alleur",
  "4450": "Juprelle",
  "4451": "Voroux-lez-Liers",
  "4452": "Paifve",
  "4453": "Villers-Saint-Siméon",
  "4458": "Fexhe-Slins",
  "4460": "Grâce-Hollogne",
  "4470": "Saint-Georges-sur-Meuse",
  "4480": "Engis",
  "4500": "Huy",
  "4520": "Wanze",
  "4530": "Villers-le-Bouillet",
  "4537": "Verlaine",
  "4540": "Amay",
  "4550": "Nandrin",
  "4557": "Tinlot",
  "4560": "Clavier",
  "4570": "Marchin",
  "4577": "Modave",
  "4590": "Ouffet",
  "4600": "Visé",
  "4601": "Argenteau",
  "4602": "Cheratte",
  "4606": "Saint-André",
  "4607": "Dalhem",
  "4608": "Warsage",
  "4610": "Beyne-Heusay",
  "4620": "Fléron",
  "4621": "Retinne",
  "4623": "Magnée",
  "4624": "Romsée",
  "4630": "Soumagne",
  "4631": "Évegnée",
  "4632": "Cérexhe-Heuseux",
  "4633": "Melen",
  "4650": "Herve",
  "4651": "Battice",
  "4652": "Xhendelesse",
  "4653": "Bolland",
  "4654": "Charneux",
  "4670": "Blégny",
  "4671": "Barchon",
  "4672": "Saint-Remy",
  "4680": "Oupeye",
  "4681": "Hermalle-sous-Argenteau",
  "4682": "Heure-le-Romain",
  "4683": "Vivegnis",
  "4684": "Haccourt",
  "4690": "Bassenge",
  "4700": "Eupen",
  "4710": "Lontzen",
  "4720": "La Calamine",
  "4721": "Neu-Moresnet",
  "4728": "Hergenrath",
  "4730": "Raeren",
  "4731": "Eynatten",
  "4750": "Butgenbach",
  "4760": "Bullange",
  "4770": "Amblève",
  "4780": "Saint-Vith",
  "4790": "Burg-Reuland",
  "4800": "Verviers",
  "4801": "Stembert",
  "4802": "Heusy",
  "4820": "Dison",
  "4821": "Andrimont",
  "4830": "Limbourg",
  "4831": "Bilstain",
  "4834": "Goé",
  "4837": "Baelen",
  "4840": "Welkenraedt",
  "4841": "Henri-Chapelle",
  "4845": "Jalhay",
  "4850": "Plombières",
  "4851": "Gemmenich",
  "4852": "Hombourg",
  "4860": "Pepinster",
  "4861": "Soiron",
  "4870": "Trooz",
  "4880": "Aubel",
  "4890": "Thimister-Clermont",
  "4900": "Spa",
  "4910": "Theux",
  "4920": "Aywaille",
  "4950": "Waimes",
  "4960": "Malmedy",
  "4970": "Stavelot",
  "4980": "Trois-Ponts",
  "4983": "Basse-Bodeux",
  "4987": "Stoumont",
  "4990": "Lierneux",
  "5000": "Namur",
  "5001": "Belgrade",
  "5002": "Saint-Servais",
  "5003": "Saint-Marc",
  "5004": "Bouge",
  "5010": "Namur",
  "5012": "Erpent",
  "5020": "Champion",
  "5021": "Boninne",
  "5022": "Cognelée",
  "5024": "Marche-les-Dames",
  "5030": "Gembloux",
  "5031": "Grand-Manil",
  "5032": "Bossière",
  "5060": "Sambreville",
  "5070": "Fosses-la-Ville",
  "5080": "La Bruyère",
  "5081": "Bovesse",
  "5100": "Jambes",
  "5101": "Lives-sur-Meuse",
  "5140": "Sombreffe",
  "5150": "Floreffe",
  "5170": "Profondeville",
  "5190": "Jemeppe-sur-Sambre",
  "5300": "Andenne",
  "5310": "Eghezée",
  "5330": "Assesse",
  "5332": "Crupet",
  "5333": "Sorinne-la-Longue",
  "5334": "Florée",
  "5336": "Courrière",
  "5340": "Gesves",
  "5350": "Ohey",
  "5351": "Haillot",
  "5352": "Perwez-Haillot",
  "5353": "Goesnes",
  "5354": "Jallet",
  "5360": "Hamois",
  "5361": "Mohiville",
  "5362": "Achet",
  "5363": "Emptinne",
  "5364": "Schaltin",
  "5370": "Havelange",
  "5372": "Méan",
  "5374": "Maffe",
  "5376": "Miécret",
  "5377": "Barvaux-Condroz",
  "5380": "Fernelmont",
  "5500": "Dinant",
  "5501": "Lisogne",
  "5502": "Thynes",
  "5503": "Sorinnes",
  "5504": "Foy-Notre-Dame",
  "5520": "Onhaye",
  "5521": "Serville",
  "5522": "Falaën",
  "5523": "Sommière",
  "5524": "Gerin",
  "5530": "Yvoir",
  "5537": "Anhée",
  "5540": "Hastière",
  "5541": "Hastière-par-delà",
  "5542": "Blaimont",
  "5543": "Heer",
  "5544": "Agimont",
  "5550": "Vresse-sur-Semois",
  "5555": "Bièvre",
  "5560": "Houyet",
  "5561": "Celles",
  "5562": "Custinne",
  "5563": "Hour",
  "5564": "Wanlin",
  "5570": "Beauraing",
  "5575": "Gedinne",
  "5580": "Rochefort",
  "5590": "Ciney",
  "5600": "Philippeville",
  "5620": "Florennes",
  "5621": "Hanzinne",
  "5630": "Cerfontaine",
  "5640": "Mettet",
  "5641": "Biesme",
  "5644": "Ermeton-sur-Biert",
  "5646": "Stave",
  "5650": "Walcourt",
  "5651": "Berzée",
  "5660": "Couvin",
  "5670": "Viroinval",
  "5680": "Doische",
  "6000": "Charleroi",
  "6001": "Marcinelle",
  "6010": "Couillet",
  "6020": "Dampremy",
  "6030": "Marchienne-au-Pont",
  "6031": "Monceau-sur-Sambre",
  "6032": "Mont-sur-Marchienne",
  "6040": "Jumet",
  "6041": "Gosselies",
  "6042": "Lodelinsart",
  "6043": "Ransart",
  "6044": "Roux",
  "6060": "Gilly",
  "6061": "Montignies-sur-Sambre",
  "6100": "Montigny-le-Tilleul",
  "6110": "Montigny-le-Tilleul",
  "6111": "Landelies",
  "6120": "Ham-sur-Heure-Nalinnes",
  "6140": "Fontaine-l'Évêque",
  "6141": "Forchies-la-Marche",
  "6142": "Leernes",
  "6150": "Anderlues",
  "6180": "Courcelles",
  "6181": "Gouy-lez-Piéton",
  "6182": "Souvret",
  "6183": "Trazegnies",
  "6200": "Châtelet",
  "6210": "Les Bons Villers",
  "6211": "Mellet",
  "6220": "Fleurus",
  "6221": "Saint-Amand",
  "6222": "Brye",
  "6223": "Wagnelée",
  "6224": "Wanfercée-Baulet",
  "6230": "Pont-à-Celles",
  "6238": "Luttre",
  "6240": "Farciennes",
  "6250": "Aiseau-Presles",
  "6260": "Aiseau-Presles",
  "6280": "Gerpinnes",
  "6440": "Froidchapelle",
  "6460": "Chimay",
  "6461": "Virelles",
  "6462": "Vaulx-lez-Chimay",
  "6463": "Lompret",
  "6464": "Baileux",
  "6470": "Sivry-Rance",
  "6500": "Beaumont",
  "6511": "Strée",
  "6530": "Thuin",
  "6531": "Biesme-sous-Thuin",
  "6532": "Ragnies",
  "6533": "Biercée",
  "6534": "Gozée",
  "6536": "Thuillies",
  "6540": "Lobbes",
  "6543": "Bienne-lez-Happart",
  "6560": "Erquelinnes",
  "6567": "Merbes-le-Château",
  "6590": "Momignies",
  "6596": "Seloignes",
  "6600": "Bastogne",
  "6630": "Martelange",
  "6637": "Fauvillers",
  "6640": "Vaux-sur-Sûre",
  "6660": "Houffalize",
  "6661": "Mont",
  "6662": "Tavigny",
  "6666": "Wibrin",
  "6670": "Gouvy",
  "6671": "Bovigny",
  "6672": "Beho",
  "6673": "Cherain",
  "6674": "Montleban",
  "6680": "Sainte-Ode",
  "6681": "Lavacherie",
  "6686": "Bertogne",
  "6687": "Bertogne",
  "6688": "Longchamps",
  "6690": "Vielsalm",
  "6692": "Petit-Thier",
  "6698": "Grand-Halleux",
  "6700": "Arlon",
  "6717": "Attert",
  "6720": "Habay",
  "6721": "Anlier",
  "6723": "Habay-la-Vieille",
  "6724": "Rulles",
  "6730": "Tintigny",
  "6740": "Étalle",
  "6741": "Vance",
  "6742": "Chantemelle",
  "6743": "Buzenol",
  "6747": "Meix-devant-Virton",
  "6750": "Musson",
  "6760": "Virton",
  "6761": "Latour",
  "6762": "Saint-Mard",
  "6767": "Rouvroy",
  "6769": "Meix-le-Tige",
  "6780": "Messancy",
  "6781": "Sélange",
  "6782": "Habergy",
  "6790": "Aubange",
  "6791": "Athus",
  "6792": "Halanzy",
  "6800": "Libramont-Chevigny",
  "6810": "Chiny",
  "6811": "Les Bulles",
  "6812": "Suxy",
  "6813": "Termes",
  "6820": "Florenville",
  "6821": "Lacuisine",
  "6823": "Villers-devant-Orval",
  "6824": "Chassepierre",
  "6830": "Bouillon",
  "6831": "Noirefontaine",
  "6832": "Sensenruth",
  "6833": "Ucimont",
  "6834": "Bellevaux",
  "6836": "Dohan",
  "6838": "Corbion",
  "6840": "Neufchâteau",
  "6850": "Paliseul",
  "6851": "Nollevaux",
  "6852": "Opont",
  "6853": "Framont",
  "6856": "Fays-les-Veneurs",
  "6860": "Léglise",
  "6870": "Saint-Hubert",
  "6880": "Bertrix",
  "6887": "Herbeumont",
  "6890": "Libin",
  "6900": "Marche-en-Famenne",
  "6920": "Wellin",
  "6921": "Chanly",
  "6922": "Halma",
  "6924": "Lomprez",
  "6927": "Tellin",
  "6929": "Daverdisse",
  "6940": "Durbuy",
  "6941": "Bomal-sur-Ourthe",
  "6950": "Nassogne",
  "6951": "Bande",
  "6952": "Grune",
  "6953": "Ambly",
  "6960": "Manhay",
  "6970": "Tenneville",
  "6971": "Champlon",
  "6980": "La Roche-en-Ardenne",
  "6982": "Samrée",
  "6983": "Ortho",
  "6984": "Hives",
  "6986": "Halleux",
  "6987": "Rendeux",
  "6990": "Hotton",
  "6997": "Érezée",
  "7000": "Mons",
  "7010": "Shape",
  "7011": "Ghlin",
  "7012": "Jemappes",
  "7020": "Nimy",
  "7021": "Havré",
  "7022": "Hyon",
  "7024": "Ciply",
  "7030": "Saint-Symphorien",
  "7031": "Villers-Saint-Ghislain",
  "7032": "Spiennes",
  "7033": "Cuesmes",
  "7034": "Obourg",
  "7040": "Quévy",
  "7050": "Jurbise",
  "7060": "Soignies",
  "7061": "Casteau",
  "7062": "Naast",
  "7063": "Chaussée-Notre-Dame-Louvignies",
  "7070": "Le Roeulx",
  "7080": "Frameries",
  "7090": "Braine-le-Comte",
  "7100": "La Louvière",
  "7110": "Houdeng-Aimeries",
  "7120": "Estinnes",
  "7130": "Binche",
  "7131": "Waudrez",
  "7133": "Buvrinnes",
  "7134": "Épinois",
  "7140": "Morlanwelz",
  "7141": "Carnières",
  "7160": "Chapelle-lez-Herlaimont",
  "7170": "Manage",
  "7180": "Seneffe",
  "7181": "Familleureux",
  "7190": "Écaussinnes",
  "7191": "Écaussinnes-d'Enghien",
  "7300": "Boussu",
  "7301": "Hornu",
  "7320": "Bernissart",
  "7321": "Harchies",
  "7322": "Ville-Pommeroeul",
  "7330": "Saint-Ghislain",
  "7331": "Baudour",
  "7332": "Sirault",
  "7333": "Tertre",
  "7334": "Hautrage",
  "7340": "Colfontaine",
  "7350": "Hensies",
  "7370": "Dour",
  "7380": "Quiévrain",
  "7382": "Audregnies",
  "7387": "Honnelles",
  "7390": "Quaregnon",
  "7500": "Tournai",
  "7501": "Orcq",
  "7502": "Esplechin",
  "7503": "Froyennes",
  "7504": "Froidmont",
  "7506": "Willemeau",
  "7520": "Templeuve",
  "7521": "Chercq",
  "7522": "Blandain",
  "7530": "Gaurain-Ramecroix",
  "7531": "Havinnes",
  "7532": "Beclers",
  "7533": "Thimougies",
  "7534": "Barry",
  "7536": "Vaulx",
  "7538": "Vezon",
  "7540": "Kain",
  "7542": "Mont-Saint-Aubert",
  "7543": "Mourcourt",
  "7548": "Warchin",
  "7600": "Péruwelz",
  "7601": "Roucourt",
  "7602": "Bury",
  "7603": "Bon-Secours",
  "7604": "Baugnies",
  "7610": "Rumes",
  "7611": "La Glanerie",
  "7618": "Taintignies",
  "7620": "Brunehaut",
  "7621": "Lesdain",
  "7622": "Laplaigne",
  "7623": "Rongy",
  "7624": "Howardries",
  "7640": "Antoing",
  "7641": "Bruyelle",
  "7642": "Calonne",
  "7643": "Fontenoy",
  "7700": "Mouscron",
  "7711": "Dottignies",
  "7712": "Herseaux",
  "7730": "Estaimpuis",
  "7740": "Pecq",
  "7742": "Hérinnes-lez-Pecq",
  "7743": "Obigies",
  "7750": "Mont-de-l'Enclus",
  "7760": "Celles",
  "7780": "Comines-Warneton",
  "7781": "Houthem",
  "7782": "Ploegsteert",
  "7783": "Le Bizet",
  "7784": "Warneton",
  "7800": "Ath",
  "7801": "Irchonwelz",
  "7802": "Ormeignies",
  "7803": "Bouvignies",
  "7810": "Maffle",
  "7811": "Arbre",
  "7812": "Mainvault",
  "7822": "Ghislenghien",
  "7823": "Gibecq",
  "7830": "Silly",
  "7850": "Enghien",
  "7860": "Lessines",
  "7861": "Papignies",
  "7862": "Ogy",
  "7863": "Ghoy",
  "7864": "Deux-Acren",
  "7866": "Bois-de-Lessines",
  "7870": "Lens",
  "7880": "Flobecq",
  "7890": "Ellezelles",
  "7900": "Leuze-en-Hainaut",
  "7901": "Thieulain",
  "7903": "Chapelle-à-Oie",
  "7904": "Pipaix",
  "7906": "Gallaix",
  "7910": "Frasnes-lez-Anvaing",
  "7911": "Frasnes-lez-Buissenal",
  "7912": "Dergneau",
  "7940": "Brugelette",
  "7941": "Attre",
  "7942": "Mévergnies-lez-Lens",
  "7943": "Cambron-Casteau",
  "7950": "Chièvres",
  "7951": "Tongre-Saint-Martin",
  "7970": "Beloeil",
  "7971": "Thumaide",
  "7972": "Quevaucamps",
  "7973": "Grandglise",
  "8000": "Bruges",
  "8020": "Oostkamp",
  "8200": "Sint-Andries",
  "8210": "Zedelgem",
  "8211": "Aartrijke",
  "8300": "Knokke-Heist",
  "8301": "Heist-aan-Zee",
  "8310": "Assebroek",
  "8340": "Damme",
  "8370": "Blankenberge",
  "8377": "Zuienkerke",
  "8380": "Bruges",
  "8400": "Ostende",
  "8420": "De Haan",
  "8421": "Vlissegem",
  "8430": "Middelkerke",
  "8431": "Wilskerke",
  "8432": "Leffinge",
  "8433": "Mannekensvere",
  "8434": "Westende",
  "8450": "Bredene",
  "8460": "Oudenburg",
  "8470": "Gistel",
  "8480": "Ichtegem",
  "8490": "Jabbeke",
  "8500": "Courtrai",
  "8501": "Heule",
  "8510": "Marke",
  "8511": "Aalbeke",
  "8520": "Kuurne",
  "8530": "Harelbeke",
  "8540": "Deerlijk",
  "8550": "Zwevegem",
  "8551": "Heestert",
  "8552": "Moen",
  "8553": "Otegem",
  "8554": "Sint-Denijs",
  "8560": "Wevelgem",
  "8570": "Anzegem",
  "8572": "Kaster",
  "8573": "Tiegem",
  "8580": "Avelgem",
  "8581": "Kerkhove",
  "8582": "Outrijve",
  "8583": "Bossuit",
  "8587": "Espierres-Helchin",
  "8600": "Dixmude",
  "8610": "Kortemark",
  "8620": "Nieuwpoort",
  "8630": "Furnes",
  "8640": "Koekelare",
  "8647": "Lo-Reninge",
  "8650": "Houthulst",
  "8660": "La Panne",
  "8670": "Koksijde",
  "8680": "Alveringem",
  "8690": "Alveringem",
  "8700": "Tielt",
  "8710": "Wielsbeke",
  "8720": "Dentergem",
  "8730": "Beernem",
  "8740": "Pittem",
  "8750": "Wingene",
  "8755": "Ruiselede",
  "8760": "Meulebeke",
  "8770": "Ingelmunster",
  "8780": "Oostrozebeke",
  "8790": "Waregem",
  "8791": "Beveren-Leie",
  "8792": "Desselgem",
  "8793": "Sint-Eloois-Vijve",
  "8800": "Roulers",
  "8810": "Lichtervelde",
  "8820": "Torhout",
  "8830": "Hooglede",
  "8840": "Staden",
  "8850": "Ardooie",
  "8860": "Lendelede",
  "8870": "Izegem",
  "8880": "Ledegem",
  "8890": "Moorslede",
  "8900": "Ypres",
  "8902": "Zillebeke",
  "8904": "Boezinge",
  "8906": "Elverdinge",
  "8908": "Vlamertinge",
  "8920": "Langemark-Poelkapelle",
  "8930": "Menin",
  "8940": "Wervik",
  "8950": "Heuvelland",
  "8951": "Dranouter",
  "8952": "Wulvergem",
  "8953": "Wijtschate",
  "8954": "Westouter",
  "8956": "Kemmel",
  "8957": "Mesen",
  "8958": "Loker",
  "8970": "Poperinge",
  "8978": "Watou",
  "8980": "Zonnebeke",
  "9000": "Gand",
  "9030": "Mariakerke",
  "9031": "Drongen",
  "9032": "Wondelgem",
  "9040": "Sint-Amandsberg",
  "9041": "Oostakker",
  "9042": "Gand",
  "9050": "Gentbrugge",
  "9051": "Sint-Denijs-Westrem",
  "9052": "Zwijnaarde",
  "9060": "Zelzate",
  "9070": "Destelbergen",
  "9080": "Lochristi",
  "9090": "Melle",
  "9100": "Saint-Nicolas",
  "9111": "Belsele",
  "9112": "Sinaai",
  "9120": "Beveren",
  "9130": "Kieldrecht",
  "9140": "Tamise",
  "9150": "Kruibeke",
  "9160": "Lokeren",
  "9170": "Sint-Gillis-Waas",
  "9180": "Moerbeke",
  "9185": "Wachtebeke",
  "9190": "Stekene",
  "9200": "Termonde",
  "9220": "Hamme",
  "9230": "Wetteren",
  "9240": "Zele",
  "9250": "Waasmunster",
  "9255": "Buggenhout",
  "9260": "Wichelen",
  "9270": "Laarne",
  "9280": "Lebbeke",
  "9290": "Berlare",
  "9300": "Alost",
  "9308": "Hofstade",
  "9310": "Moorsel",
  "9320": "Erembodegem",
  "9340": "Lede",
  "9400": "Ninove",
  "9401": "Pollare",
  "9402": "Meerbeke",
  "9403": "Neigem",
  "9404": "Aspelare",
  "9406": "Outer",
  "9420": "Erpe-Mere",
  "9450": "Haaltert",
  "9451": "Kerksken",
  "9470": "Denderleeuw",
  "9472": "Iddergem",
  "9473": "Welle",
  "9500": "Grammont",
  "9506": "Schendelbeke",
  "9520": "Sint-Lievens-Houtem",
  "9521": "Letterhoutem",
  "9550": "Herzele",
  "9551": "Ressegem",
  "9552": "Borsbeke",
  "9570": "Lierde",
  "9572": "Sint-Martens-Lierde",
  "9600": "Renaix",
  "9620": "Zottegem",
  "9630": "Brakel",
  "9636": "Nederzwalm-Hermelgem",
  "9660": "Brakel",
  "9667": "Horebeke",
  "9680": "Maarkedal",
  "9681": "Nukerke",
  "9688": "Maarke-Kerkem",
  "9690": "Kluisbergen",
  "9700": "Audenarde",
  "9750": "Zingem",
  "9770": "Kruisem",
  "9771": "Nokere",
  "9772": "Wannegem-Lede",
  "9790": "Wortegem-Petegem",
  "9800": "Deinze",
  "9810": "Nazareth",
  "9820": "Merelbeke",
  "9830": "Sint-Martens-Latem",
  "9831": "Deurle",
  "9840": "De Pinte",
  "9850": "Nevele",
  "9860": "Oosterzele",
  "9870": "Zulte",
  "9880": "Aalter",
  "9890": "Gavere",
  "9900": "Eeklo",
  "9910": "Knesselare",
  "9920": "Lievegem",
  "9921": "Vinderhoute",
  "9930": "Zomergem",
  "9940": "Evergem",
  "9950": "Waarschoot",
  "9960": "Assenede",
  "9970": "Kaprijke",
  "9980": "Sint-Laureins",
  "9988": "Waterland-Oudeman",
  "9990": "Maldegem",
};
